module.exports = {
	"header.logo.title": "Find det GROHE vandsystem til køkkenet som passer dig",
	"footer.privacy.text": "Personlige oplysninger",
	"footer.privacy.url": "https://www.grohe.dk/da_dk/databeskyttelse.html",
	"footer.disclaimer.text": "Juridisk information",
	"footer.disclaimer.url": "https://www.grohe.dk/da_dk/aftryk.html",
	"footer.copyright": "&copy; 2022 GROHE A/S",
	"homepage.headline": "Se  det vandsystem som passer til dine behov",
	"homepage.introtext": "Besvar et par spørgsmål herunder og find frem til det GROHE vandsystem til køkkenet som passer til dine behov.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 siden blev desværre ikke fundet",
	"404.link.goBack": "Gå til hjemmeside",
	"configurator.button.seeResults": "Se dit resultat",
	"question1.question": "Har du kun koldt vand tilkoblet i dit køkken og ønsker at bruge din RED som varmtvandsbeholder?",
	"question1.option1.text": "Ja",
	"question1.option2.text": "Nej",
	"question2.question": "Ønsker du filtreret, kogende vand eller filtreret, afkølet vand med brus i din vandhane?",
	"question2.option1.text": "Kognede vand",
	"question2.option2.text": "Afkølet vand med brus",
	"question2.option3.text": "Jeg ønsker muligheden for begge dele",
	"question3.question": "Ønsker du dette som supplement til din nuværende vandhane?",
	"question3.option1.text": "Ja, jeg vil gerne beholde min nuværende vandhane",
	"question3.option2.text": "Nej, jeg vil montere en ny vandhane",
	"question4.question": "Ønsker du kogende vand eller vand med brus i din primære vandhane?",
	"question4.option1.text": "Afkølet vand med brus",
	"question4.option2.text": "Kogende vand",
	"question5.question": "Hvilket design ønsker du?",
	"question5.option1.text": "L-tud",
	"question5.option2.text": "C-tud",
	"question5.option3.text": "U-tud",
	"question6.question": "Skal vandhanen have udtrækkelig tud?",
	"question6.option1.text": "Ja",
	"question6.option2.text": "Nej",
	"question7.question": "Hvilken farve foretrækker du?",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Supersteel",
	"question7.option3.text": "Brushed Hard Graphite",
	"question7.option4.text": "Brushed Warm Sunset",
	"question7.option5.text": "Velvet Black",
	"question8.question": "Hvor meget kogende vand har du behov for at tappe på en gang?",
	"question8.option1.text": "3 liter",
	"question8.option2.text": "5,5 liter",
	"results.title": "{productGroupsCount, plural, \none {Dit resultat} \nother {Dine resultater}\n}",
	"results.proposal.title": "Forslag {number}",
	"results.proposal.title.single": "Forslag",
	"results.bundle.title": "For at installere vandsystemet skal du også bruge:",
	"results.newConfiguration.title": "Ønsker du at besvare spørgsmålene igen?",
	"results.newConfiguration.buttonText": "Start konfiguratoren igen",
	"results.product.number": "Produktnummer: #{number}",
	"results.product.button.productInformation": "Productinformation",
	"results.product.button.dealerLocator": "Find nærmeste showroom",
	"results.product.button.buyNow": "Køb online",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produktinformation",
	"results.product.dealer": "Find nærmeste showroom",
	"hatchModal.title": "Køb online",
	"hatchModal.btnText": "Køb online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Ikke på lager} \nother {På lager}\n}",
	"hatchModal.buyNow": "Køb online"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.da_dk.json
// module id = 772
// module chunks = 0